import { defineComponent } from "vue";

import { PAGE_NAME } from "./attributes";

import { LoginForm } from "@/components/pages/login";
import { SharedAuthCard, SharedModal2fa } from "@/components/shared";
import { UILink } from "@/components/ui";

import { Error } from "@/shared/constants/interfaces";
import { AuthLoginRequestFactory } from "@/shared/repository/modules/auth/factory";
import { RoutesName } from "@/shared/constants/enums";
import { formatSecondsToMMSS } from "@/shared/utils/time-helpers";

export default defineComponent({
  name: PAGE_NAME,
  components: {
    LoginForm,
    SharedAuthCard,
    SharedModal2fa,
    UILink,
  },
  data() {
    return {
      message: "",
      isLoading: false,
      authLoginRequest: AuthLoginRequestFactory(),
      authRepository: this.$projectServices.authRepository,
      show2faModal: false,
      requiresMail2fa: false,
      requiresGoogle2fa: false,
    };
  },
  methods: {
    async handleLogin(): Promise<void> {
      try {
        this.isLoading = true;
        this.message = "";

        const response = await this.authRepository.login(this.authLoginRequest);

        if (
          response &&
          (response.requires_mail_2fa || response.requires_google_2fa)
        ) {
          this.requiresMail2fa = response.requires_mail_2fa || false;
          this.requiresGoogle2fa = response.requires_google_2fa || false;
          this.show2faModal = true;
          return;
        }

        this.$router.push({ name: RoutesName.wallet });
      } catch (e) {
        const error = <Error>e;

        if (error.error === "throttle" && error.retry_after) {
          const timeFormatted = formatSecondsToMMSS(error.retry_after);
          this.message = this.$t(
            "Too many login attempts. Please try again after {time}",
            { time: timeFormatted }
          );
        } else {
          this.message = error.message;
        }
      } finally {
        this.isLoading = false;
      }
    },

    handleGoogle(): void {
      console.log("Google");
    },

    handle2faClose(): void {
      this.show2faModal = false;
      this.requiresMail2fa = false;
      this.requiresGoogle2fa = false;
    },

    handle2faConfirm(): void {
      // Логика подтверждения теперь обрабатывается в модальном окне
      // Здесь только закрываем модальное окно и переходим в кошелек
      this.show2faModal = false;
      this.$router.push({ name: RoutesName.wallet });
    },
  },
});
